import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import Header from "./Header";
import RobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import RobotoMedium from "../../assets/fonts/Roboto/Roboto-Medium.ttf";
import RobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";
import RobotoRegular from "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import DirectDebitImage from "../../assets/images/direct-debit-image.jpeg";
import ScissorsIcon from "../../assets/images/scissor-image.jpeg";
import TermsAndCondition from "./TermsAndCondition";
import moment from "moment";
import { COUNTIES, POSITION } from "../../lib/Variable";

// Register font
Font.register({ family: "RobotoLight", src: RobotoLight });
Font.register({ family: "RobotoBold", src: RobotoBold });
Font.register({ family: "RobotoMedium", src: RobotoMedium });
Font.register({ family: "RobotoRegular", src: RobotoRegular });

const DirectDebitGuarantee = [
  `This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits `,

  `If there are any changes to the amount, date or frequency of your Direct Debit Nova Connect(UK) Ltd will notify you at least 14 working days in advance of your account being debited or as otherwise agreed. If you request Nova Connect(UK) Ltd to collect a payment, confirmation of the amount and date will be given to you at the time of the request.`,

  `If an error is made in the payment of your Direct Debit, by Nova Connect(UK) Ltd or your bank or building society, you are entitled to a full immediate refund of the amount paid from your bank or building society.`,

  `If you receive a refund you are not entitled to, you must pay it back when Nova Connect(UK) Ltd asks you to`,

  `You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us. `,
];

const styles = StyleSheet.create({
  body: {
    padding: 20,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  tableRowLast: {
    flexDirection: "row",
  },
  tableCell: {
    width: "32%",
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  tableCellLast: {
    width: "32%",
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  tableCellRight: {
    width: "68%",
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
  },

  tableCellRightSplit: {
    flexDirection: "row",
    width: "68%",
  },
  tableCellRightInput: {
    flex: 1,
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  tableCellRightLabel: {
    width: "25%",
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  tableCellRightValue: {
    flex: 1,
    padding: 5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
  },

  keyInformationTable: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 10,
  },
  keyInformationTableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  keyInformationTableRowLast: {
    flexDirection: "row",
  },
  keyInformationTableCell: {
    width: "32%",
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  keyInformationTableCellLast: {
    width: "32%",
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  keyInformationTableCellRight: {
    width: "68%",
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
  },

  keyInformationTableCellRightSplit: {
    flexDirection: "row",
    width: "68%",
  },
  keyInformationTableCellRightInput: {
    flex: 1,
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  keyInformationTableCellRightLabel: {
    width: "25%",
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  keyInformationTableCellRightValue: {
    flex: 1,
    padding: 3.5,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
  },

  sectionTitle: {
    fontSize: 10,
    fontFamily: "RobotoBold",
    fontWeight: "600",
    marginBottom: 6,
  },
  equipmentTable: {
    width: "100%",
  },
  equipmentContainer: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
  },
  equipmentTableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  equipmentTableRowLast: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  equipmentTableHeader: {
    fontSize: 4,
    color: "#000000",
    fontSize: 9,
    padding: 3,
  },
  equipmentTableHeader1: {
    width: "20%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableHeader2: {
    width: "30%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableHeader3: {
    width: "35%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableHeader4: {
    width: "15%",
  },
  equipmentTableCell: {
    padding: 6,
    fontSize: 9,
    fontFamily: "RobotoLight",
    color: "#000000",
  },
  equipmentTableCell1: {
    width: "20%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableCell2: {
    width: "30%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableCell3: {
    width: "35%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  equipmentTableCell4: {
    width: "15%",
  },
  minimumTerm: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    marginTop: 6,
    marginBottom: 6,
  },
  bulletPoint: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    // marginBottom: 6,
    paddingLeft: 5,
    lineHeight: 1.4,
  },
  underlinedText: {
    textDecoration: "underline",
  },
  boldText: {
    fontFamily: "RobotoBold",
    fontWeight: "600",
  },
  paymentContainer: {
    flexDirection: "row",
    marginTop: 2,
    borderTopWidth: 1,
    borderTopColor: "#000000",
    borderTopStyle: "solid",
    // marginBottom: 10,
  },
  paymentField: {
    flex: 1,
    padding: 8,
    fontSize: 9,
    fontFamily: "RobotoLight",
  },
  paymentFieldRight: {
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  paymentFieldLeft: {
    // borderRightWidth: 1,
    // borderRightColor: "#000000",
    // borderRightStyle: "solid",
  },
  signatureContainer: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginTop: 10,
  },

  signatureFieldLeft: {
    width: "50%",
    padding: 3,
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  signatureFieldRight: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    // padding: 3,1
  },
  signatureFieldRightPortion1: {
    // width: "50%",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    padding: 3,
  },
  signatureFieldRightPortion2: {
    // width: "50%",
    padding: 3,
  },

  signatureFieldTtitle: {
    fontSize: 11,
    fontFamily: "RobotoBold",
    fontWeight: "600",
  },
  signatureFieldSubtitle: {
    fontSize: 10,
    fontFamily: "RobotoLight",
    fontWeight: "300",
  },
  signatureArea: {
    width: "100%",
    height: 40,
  },
  signatureFieldText: {
    fontSize: 10,
    fontFamily: "RobotoLight",
    fontWeight: "300",
    marginBottom: 5,
  },
  termsAndConditionsTitle: {
    fontSize: 16,
    // fontFamily: "RobotoBold",
    // fontWeight: "600",
    marginBottom: 6,
    textAlign: "center",
  },

  dotedBorder: {
    width: "100%",
    height: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderStyle: "dashed",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    marginVertical: 10,
  },
  directDebitContainer: {
    // marginTop: 10,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  directDebitContainer1: {
    width: "50%",
    // height: "500px",
    paddingHorizontal: 8,
  },
  directDebitContainer2: {
    width: "50%",
    // height: "500px",
    paddingHorizontal: 8,
    // backgroundColor: "red",
    // borderWidth: 1,
    // borderColor: "#000000",
    // borderStyle: "solid",
  },
  directDebitText1: {
    fontSize: 9.5,
    fontFamily: "RobotoLight",
    fontWeight: "300",
  },
  directDebitNovaConnect: {
    width: "100%",
    marginTop: 15,
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    padding: 4,
  },
  directDebitNovaConnectText: {
    fontSize: 12,
    fontFamily: "RobotoRegular",
    fontWeight: "400",
    lineHeight: 1.2,
  },

  directDebitNovaConnectInputLabel: {
    fontSize: 9,
    marginBottom: 5,
  },

  directDebitNovaConnectInput: {
    width: "100%",
    height: 30,
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    // padding: 4,
  },
  directDebitNovaConnectCodeInputContainer: {
    display: "flex",
    flexDirection: "row",
    // gap: 10,
  },
  cutLineContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 10,
    marginBottom: 10,
    width: "100%",
    justifyContent: "flex-start",
  },
  scissorsIconImage: {
    width: "15px",
  },
  cutLine: {
    flex: 1,
    height: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderStyle: "dashed",
    marginLeft: 0,
    maxWidth: "calc(100% - 30px)",
  },
  guaranteeContainer: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginTop: 15,
    marginBottom: 10,
    padding: 10,
    width: "100%",
  },

  directDebitNovaConnectCodeInput: {
    width: "10%",
    height: 30,
    border: "1px solid #000000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRightWidth: "none",
  },
  directDebitNovaConnectInputText: {
    fontSize: 12,
    // padding: 4,
  },
  directDebitImageContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  directDebitImage: {
    width: "120px",
  },
  directDebitInstructionText: {
    fontSize: 13,
    fontFamily: "RobotoMedium",
    fontWeight: "600",
    marginTop: 10,
    textAlign: "center",
    paddingHorizontal: 4,
  },

  directDebitNovaConnectInstruction: {
    height: 100,
    borderWidth: 2,
    borderColor: "#000000",
    borderStyle: "solid",
    paddingVertical: 2,
    paddingHorizontal: 6,
    marginTop: 10,
  },

  directDebitNovaConnectInstructionText: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    fontWeight: "300",
    marginBottom: 8,
  },
  directDebitNovaConnectInstructionSubText: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    fontWeight: "300",
  },
  directDebitBankInstructionText: {
    fontSize: 9,
    fontFamily: "RobotoMedium",
    fontWeight: "600",
    marginBottom: 8,
  },

  directDebitBankInstructionSubText: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    fontWeight: "300",
    letterSpacing: 0.8,
    lineHeight: 1.4,
  },

  directDebitSignatureArea: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    borderRight: "none",
  },

  directDebitSignatureRow: {
    height: 25,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 8,
  },
  directDebitSignatureText: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    fontWeight: "300",
  },

  // Bank Address Area Styles
  directDebitBankAddressArea: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    // marginTop: 10,
  },

  directDebitBankAddressRow: {
    height: 30,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 8,
  },

  directDebitBankAddressText: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    fontWeight: "300",
  },

  // Direct debit guarantee container

  directDebitGuaranteeContainer: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    padding: 6,
  },

  directDebitGuaranteeLabel: {
    fontSize: 9,
    fontFamily: "RobotoBold",
    fontWeight: "600",
    textAlign: "center",
  },

  directDebitGuaranteeImageContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 8,
    marginBottom: 8,
  },
  directDebitGuaranteeImage: {
    width: "100px",
  },
  guaranteeContent: {
    width: "100%",
    marginTop: 10,
  },
  guaranteeItem: {
    flexDirection: "row",
    marginBottom: 2,
    // width: "100%",
    // alignItems: "flex-start",
  },
  guaranteeBullet: {
    fontSize: 9,
    fontFamily: "RobotoLight",
    marginRight: 5,
    marginTop: 0,
  },
  guaranteeText: {
    fontSize: 8.5,
    fontFamily: "RobotoLight",
    fontWeight: "300",
    lineHeight: 1.4,
    width: "100%",
  },
});

const AggrementPdf = ({ inputValues = {} }) => {
  const accountNumber = inputValues?.bankAccountNumber;
  const shortCode = inputValues?.bankSortCode || "";

  const accountNumberArray = accountNumber.split("");
  const shortCodeArray = shortCode.split("");
  const serviceUserNumberArray = Array.from({ length: 8 });
  const referenceNumberArray = Array.from({ length: 18 });

  const renderAccountNumber = () => {
    return (
      <View style={styles.directDebitNovaConnectCodeInputContainer}>
        {accountNumberArray.map((item, index) => (
          <View
            style={[
              styles.directDebitNovaConnectCodeInput,
              index === accountNumberArray.length - 1 && {
                borderRight: "1px solid #000000",
              },
            ]}
          >
            <Text style={styles.directDebitNovaConnectInputText}>{item}</Text>
          </View>
        ))}
      </View>
    );
  };

  const renderShortCode = () => {
    return (
      <View style={styles.directDebitNovaConnectCodeInputContainer}>
        {shortCodeArray.map((item, index) => (
          <View
            style={[
              styles.directDebitNovaConnectCodeInput,
              index === shortCodeArray.length - 1 && {
                borderRight: "1px solid #000000",
              },
            ]}
          >
            <Text style={styles.directDebitNovaConnectInputText}>{item}</Text>
          </View>
        ))}
      </View>
    );
  };

  const renderServiceUserNumber = () => {
    return (
      <View style={styles.directDebitNovaConnectCodeInputContainer}>
        {serviceUserNumberArray.map((item, index) => (
          <View
            style={[
              styles.directDebitNovaConnectCodeInput,
              { width: "16.666%", height: 40 },
              index === serviceUserNumberArray.length - 1 && {
                borderRight: "1px solid #000000",
              },
            ]}
          >
            <Text style={styles.directDebitNovaConnectInputText}>{item}</Text>
          </View>
        ))}
      </View>
    );
  };

  const renderReferenceNumber = () => {
    return (
      <View style={styles.directDebitNovaConnectCodeInputContainer}>
        {referenceNumberArray.map((item, index) => (
          <View
            style={[
              styles.directDebitNovaConnectCodeInput,
              { width: "5.5555%" },
              index === referenceNumberArray.length - 1 && {
                borderRight: "1px solid #000000",
              },
            ]}
          >
            <Text style={styles.directDebitNovaConnectInputText}>{item}</Text>
          </View>
        ))}
      </View>
    );
  };

  const renderDirectDebitGuarantee = () => {
    return (
      <View style={styles.guaranteeContent}>
        {DirectDebitGuarantee.map((item, index) => (
          <View key={index} style={[styles.guaranteeItem]}>
            <Text style={styles.guaranteeBullet}>•</Text>
            <Text style={styles.guaranteeText}>{item}</Text>
          </View>
        ))}
      </View>
    );
  };

  const address = inputValues?.bankAddress || "";
  const firstLine = address.length > 45 ? address.substring(0, 45) : address;
  const secondLine = address.length > 45 ? address.substring(45) : "";

  console.table(inputValues, "inputValues");
  return (
    <Document>
      <Page size="A4" wrap style={styles.body}>
        <Header inputValues={inputValues} />
        {/* Service Providers Table */}
        <View style={styles.table}>
          {/* Row 1 */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>
              Service Providers: ("we" or "us")
            </Text>
            <Text style={styles.tableCellRight}>Nova Connect (UK) Ltd</Text>
          </View>

          {/* Row 2 */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>Supplier of Services ("EIT")</Text>
            <Text style={styles.tableCellRight}>
              European Information Technology Limited
            </Text>
          </View>

          {/* Row 3 */}
          <View style={styles.tableRowLast}>
            <Text style={styles.tableCellLast}>Help Desk</Text>
            <Text style={styles.tableCellRight}>01322318809</Text>
          </View>
        </View>
        {/* Key Information Table */}

        <Text style={styles.sectionTitle}>Key Information</Text>
        <View style={styles.keyInformationTable}>
          {/* Row 1 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Merchant ("you", "your") Business Name
            </Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.businessName || ""}
            </Text>
          </View>

          {/* Row 2 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Trading Name (if different)
            </Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.tradingName || ""}
            </Text>
          </View>

          {/* Row 3 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Address Line 1</Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.addressLine1 || ""}
            </Text>
          </View>

          {/* Row 4 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Address Line 2 (optional)
            </Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.addressLine2 || ""}
            </Text>
          </View>

          {/* Row 5 - Split Column */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Town/City</Text>
            <View style={styles.keyInformationTableCellRightSplit}>
              <Text style={styles.keyInformationTableCellRightInput}>
                {inputValues?.town || ""}
              </Text>
              <Text style={styles.keyInformationTableCellRightLabel}>
                County
              </Text>
              <Text style={styles.keyInformationTableCellRightValue}>
                {COUNTIES?.find((item) => item.value === inputValues?.county)
                  ?.title || ""}
              </Text>
            </View>
          </View>

          {/* Row 6 - Split Column */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Postcode</Text>
            <View style={styles.keyInformationTableCellRightSplit}>
              <Text style={styles.keyInformationTableCellRightInput}>
                {inputValues?.postcode || ""}
              </Text>
              <Text style={styles.keyInformationTableCellRightLabel}>
                Country
              </Text>
              <Text style={styles.keyInformationTableCellRightValue}>
                {inputValues?.country || ""}
              </Text>
            </View>
          </View>

          {/* Row 7 - Split Column */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Business Phone number
            </Text>
            <View style={styles.keyInformationTableCellRightSplit}>
              <Text style={styles.keyInformationTableCellRightInput}>
                {inputValues?.businessPhone || ""}
              </Text>
              <Text style={styles.keyInformationTableCellRightLabel}>
                Years in Business
              </Text>
              <Text style={styles.keyInformationTableCellRightValue}>
                {inputValues?.yearsInBusiness || ""}
              </Text>
            </View>
          </View>

          {/* Row 8 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Business URL</Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.businessUrl || ""}
            </Text>
          </View>

          {/* Row 9 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Email Address</Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.email || ""}
            </Text>
          </View>

          {/* Row 10 - Split Column */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Company Registration Number
            </Text>
            <View style={styles.keyInformationTableCellRightSplit}>
              <Text style={styles.keyInformationTableCellRightInput}>
                {inputValues?.registrationNo || ""}
              </Text>
              <Text style={styles.keyInformationTableCellRightLabel}>
                VAT No
              </Text>
              <Text style={styles.keyInformationTableCellRightValue}>
                {inputValues?.vatNo || ""}
              </Text>
            </View>
          </View>

          {/* Row 11 - Split Column */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>Contact Name</Text>
            <View style={styles.keyInformationTableCellRightSplit}>
              <Text style={styles.keyInformationTableCellRightInput}>
                {inputValues?.contactName || ""}
              </Text>
              <Text style={styles.keyInformationTableCellRightLabel}>
                Position
              </Text>
              <Text style={styles.keyInformationTableCellRightValue}>
                {POSITION?.find((item) => item.value === inputValues?.position)
                  ?.title || ""}
              </Text>
            </View>
          </View>

          {/* Row 12 */}
          <View style={styles.keyInformationTableRow}>
            <Text style={styles.keyInformationTableCell}>
              Contact Phone Number
            </Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.contactPhone || ""}
            </Text>
          </View>

          {/* Row 13 */}
          <View style={styles.keyInformationTableRowLast}>
            <Text style={styles.keyInformationTableCellLast}>
              Installation Address
            </Text>
            <Text style={styles.keyInformationTableCellRight}>
              {inputValues?.installationAddress || ""}
            </Text>
          </View>
        </View>

        {/* Description of Equipment */}

        <Text style={styles.sectionTitle}>Description of Equipment:</Text>
        <View style={styles.equipmentContainer}>
          <View style={styles.equipmentTable}>
            {/* Header Row */}
            <View style={styles.equipmentTableRow}>
              <Text
                style={[
                  styles.equipmentTableHeader1,
                  styles.equipmentTableHeader,
                ]}
              >
                MID
              </Text>
              <Text
                style={[
                  styles.equipmentTableHeader2,
                  styles.equipmentTableHeader,
                ]}
              >
                Equipment Model
              </Text>
              <Text
                style={[
                  styles.equipmentTableHeader3,
                  styles.equipmentTableHeader,
                ]}
              >
                Accessories (Sim Card, Weblink, Base etc)
              </Text>
              <Text
                style={[
                  styles.equipmentTableHeader4,
                  styles.equipmentTableHeader,
                ]}
              >
                Quantity
              </Text>
            </View>
            {/* Data Row */}
            <View style={styles.equipmentTableRowLast}>
              <Text
                style={[styles.equipmentTableCell, styles.equipmentTableCell1]}
              >
                {" "}
              </Text>
              <Text
                style={[styles.equipmentTableCell, styles.equipmentTableCell2]}
              >
                {inputValues?.equipmentModel || ""}
              </Text>
              <Text
                style={[styles.equipmentTableCell, styles.equipmentTableCell3]}
              >
                Sim Card
              </Text>
              <Text
                style={[styles.equipmentTableCell, styles.equipmentTableCell4]}
              >
                {inputValues?.quantity || ""}
              </Text>
            </View>
          </View>

          <View style={{ padding: 4 }}>
            {/* Minimum Term */}
            <Text style={styles.minimumTerm}>
              Minimum Term: {inputValues?.minTerm || "18"} (months)
            </Text>

            {/* Bullet Points */}
            <Text style={styles.bulletPoint}>
              • If this Agreement ends before the end of the Minimum Term, the
              Termination Payment in accordance with clause 8.2 may be payable.
            </Text>
            <Text style={styles.bulletPoint}>
              • At the end of the Minimum Term this Agreement will automatically
              renew and continue in accordance with clause 1.
            </Text>
            <Text style={styles.bulletPoint}>
              • All charges related to this Agreement shall be paid in
              accordance with clause 4.
            </Text>
            <Text style={styles.bulletPoint}>
              • The standard Terms and Conditions set out below form part of
              this POS Terminal and Hire Services Contract .
            </Text>
          </View>

          {/* Payment Fields */}
          <View style={styles.paymentContainer}>
            <View style={[styles.paymentField, styles.paymentFieldRight]}>
              <Text>
                On-site Installation Payment:{" "}
                <Text style={styles.boldText}>£</Text>{" "}
                {inputValues?.onSitePayment || "       "} exc. VAT
              </Text>
            </View>
            <View style={styles.paymentField}>
              <Text>
                Total Monthly Payment: <Text style={styles.boldText}>£</Text>{" "}
                {inputValues?.monthlyPayment || "      "} exc. VAT
              </Text>
            </View>
          </View>
        </View>

        {/* Signature */}

        <View style={styles.signatureContainer}>
          <View style={styles.signatureFieldLeft}>
            <Text style={styles.signatureFieldTtitle}>
              Signature of Merchant:
            </Text>
            <Text style={styles.signatureFieldSubtitle}>
              Signed for & on behalf of the Merchant:
            </Text>
            <View style={styles.signatureArea}></View>

            <Text style={styles.signatureFieldText}>
              Print Name: {inputValues?.contactName || ""}
            </Text>
            <Text style={styles.signatureFieldText}>
              Position in Company: {inputValues?.position || ""}
            </Text>
            <Text style={styles.signatureFieldTtitle}>
              Date of Agreement: {moment(new Date()).format("DD.MM.YY")}
            </Text>
          </View>
          <View style={styles.signatureFieldRight}>
            <View style={styles.signatureFieldRightPortion1}>
              <Text style={styles.signatureFieldTtitle}>
                Signature of the Service Provider:
              </Text>
              <Text style={styles.signatureFieldSubtitle}>
                Signed for and on behalf of the Service Provider:
              </Text>
              {/* Signature Area  */}
              <View style={styles.signatureArea}></View>
            </View>
            <View style={styles.signatureFieldRightPortion2}>
              <Text style={styles.signatureFieldTtitle}>
                Signature of Supplier of Services:
              </Text>
              <Text style={styles.signatureFieldSubtitle}>
                Signed for and on behalf of EIT:
              </Text>
              {/* Signature Area  */}
              <View style={styles.signatureArea}></View>
            </View>
          </View>
        </View>
      </Page>
      <TermsAndCondition />
      <Page size="A4" wrap style={styles.body}>
        <View style={styles.dotedBorder}> </View>
        <View style={styles.directDebitContainer}>
          {/* Debit container 1 */}
          <View style={styles.directDebitContainer1}>
            <Text style={styles.directDebitText1}>
              Please fill in the whole form including official use box using a
              ball point pen and send it to:
            </Text>

            {/* Nova Connect (UK) Ltd */}
            <View style={styles.directDebitNovaConnect}>
              <Text style={styles.directDebitNovaConnectText}>
                Nova Connect(UK) Ltd{" "}
              </Text>
              <Text style={styles.directDebitNovaConnectText}>
                3 Redwing Court{" "}
              </Text>
              <Text style={styles.directDebitNovaConnectText}>
                Ashton Road{" "}
              </Text>
              <Text style={styles.directDebitNovaConnectText}>
                Romford, Essex
              </Text>
              <Text style={styles.directDebitNovaConnectText}>RM3 8QQ </Text>
            </View>

            <View style={{ marginTop: 10 }}>
              <Text style={styles.directDebitNovaConnectInputLabel}>
                Names(s) of Account Holder(s)
              </Text>
              <View
                style={[
                  styles.directDebitNovaConnectInput,
                  {
                    display: "flex",
                    justifyContent: "center",
                    paddingHorizontal: 4,
                    overflow: "hidden",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.directDebitNovaConnectInputText,
                    { fontSize: 10 },
                  ]}
                >
                  {inputValues?.nameOnAccount || ""}
                </Text>
              </View>
            </View>
            <View style={{ marginTop: 10 }}>
              <Text style={styles.directDebitNovaConnectInputLabel}>
                Bank/Building Society account number
              </Text>
              {renderAccountNumber()}
            </View>
            <View style={{ marginTop: 10 }}>
              <Text style={styles.directDebitNovaConnectInputLabel}>
                Branch Sort Code
              </Text>
              {renderShortCode()}
            </View>

            <Text
              style={{
                ...styles.directDebitNovaConnectInputLabel,
                marginTop: 10,
                fontSize: 8,
              }}
            >
              Name and full postal address of your Bank or Building Society
            </Text>

            {/* Bank Address */}
            <View style={styles.directDebitBankAddressArea}>
              {/* Row 1 */}
              <View
                style={{
                  ...styles.directDebitBankAddressRow,
                  borderBottom: "1px solid #000000",
                  alignItems: "flex-start",
                }}
              >
                <View style={{ width: "50%" }}>
                  <Text style={{ fontSize: 8 }}>To: The Manager</Text>
                </View>
                <View style={{ width: "50%" }}>
                  <Text style={{ fontSize: 8, width: "100%" }}>
                    Bank/Building society
                  </Text>
                  <Text
                    style={{
                      fontSize: 9,
                      width: "100%",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      marginTop: 2,
                      fontFamily: "RobotoLight",
                    }}
                  >
                    {inputValues?.bankName || ""}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.directDebitBankAddressRow,
                  borderBottom: "1px solid #000000",
                }}
              >
                <Text
                  style={{
                    ...styles.directDebitBankAddressText,
                  }}
                >
                  Address : {firstLine || ""}
                </Text>
              </View>
              <View
                style={{
                  ...styles.directDebitBankAddressRow,
                  borderBottom: "1px solid #000000",
                }}
              >
                {secondLine && (
                  <Text style={{ ...styles.directDebitBankAddressText }}>
                    {secondLine}
                  </Text>
                )}
              </View>
              <View style={{ ...styles.directDebitBankAddressRow }}>
                <Text style={styles.directDebitBankAddressText}>
                  Post Code : {inputValues?.bankPostCode || ""}
                </Text>
              </View>
            </View>

            <View style={{ marginTop: 10 }}>
              <Text style={styles.directDebitNovaConnectInputLabel}>
                Reference Number
              </Text>
              {renderReferenceNumber()}
            </View>
          </View>

          <View style={styles.directDebitContainer2}>
            <View style={styles.directDebitImageContainer}>
              <Image src={DirectDebitImage} style={styles.directDebitImage} />
            </View>

            <Text style={styles.directDebitInstructionText}>
              Instruction to your Bank or Building Society to pay by Direct
              Debit
            </Text>

            <View style={{ marginTop: 15 }}>
              <Text
                style={{
                  ...styles.directDebitNovaConnectInputLabel,
                  textAlign: "center",
                }}
              >
                Service User Number
              </Text>
              {renderServiceUserNumber()}
            </View>

            {/* Nova connect instruction  */}

            <View style={styles.directDebitNovaConnectInstruction}>
              <Text style={styles.directDebitNovaConnectInstructionText}>
                FOR NOVA CONNECT(UK) LTD OFFICIAL USE ONLY
              </Text>
              <Text style={styles.directDebitNovaConnectInstructionSubText}>
                This is not part of the instruction to your Bank or Building
                Society.
              </Text>
            </View>

            {/* Bank Instruction Container */}
            <View style={{ marginTop: 20, marginBottom: 20 }}>
              <Text style={styles.directDebitBankInstructionText}>
                Instruction to your Bank or Building Society
              </Text>
              <Text style={styles.directDebitBankInstructionSubText}>
                Please pay Nova Connect(UK) Ltd Direct Debits from the account
                detailed in this Instruction subject to the safeguards assured
                by the Direct Debit Guarantee. I understand this Instruction may
                remain with Nova Connect(UK) Ltd and, if so, details will be
                passed electronically to my Bank/Building Society.
              </Text>
            </View>

            {/* Signature Area */}
            <View style={styles.directDebitSignatureArea}>
              {/* Row 1 */}
              <View
                style={{
                  ...styles.directDebitSignatureRow,
                  borderBottom: "1px solid #000000",
                }}
              >
                <Text
                  style={{
                    ...styles.directDebitSignatureText,
                  }}
                >
                  Signature(s)
                </Text>
              </View>
              <View
                style={{
                  ...styles.directDebitSignatureRow,
                  borderBottom: "1px solid #000000",
                }}
              ></View>
              <View style={{ ...styles.directDebitSignatureRow }}>
                <Text style={styles.directDebitSignatureText}>
                  Date: {moment(new Date()).format("DD.MM.YY")}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 20 }}>
          <Text style={{ fontSize: 11, textAlign: "center" }}>
            Banks and Building Societies may not accept Direct Debit
            Instructions for some types of account
          </Text>
        </View>

        {/* Cut Line with Scissors */}
        <View style={styles.cutLineContainer}>
          <Image src={ScissorsIcon} style={styles.scissorsIconImage} />
          <View style={styles.cutLine}></View>
        </View>

        {/* Direct Debit Guarantee Container */}
        <View style={styles.directDebitGuaranteeContainer}>
          <Text style={styles.directDebitGuaranteeLabel}>
            This Guarantee should be detached and retained by the payer.{" "}
          </Text>
          <View style={styles.directDebitGuaranteeImageContainer}>
            <Image
              src={DirectDebitImage}
              style={styles.directDebitGuaranteeImage}
            />
          </View>
          <Text style={styles.directDebitGuaranteeLabel}>
            The Direct Debit Guarantee
          </Text>
          {renderDirectDebitGuarantee()}
        </View>
      </Page>
    </Document>
  );
};

export default AggrementPdf;
